module.exports = __webpack_public_path__ + "assets/media/moreMenu-odnoklassniki.2d120e87.svg";